import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class BusinessAreaService {

  baseUrl = "https://predev.one-qms.com/oneqms-service-v1/oneqms"

    // baseUrl = "http://localhost:8080/oneqms";

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      'Cache-Control': 'no-cache'
    }),
  };
  recordIdTosave: any;
  excutionDetails: any;
  fromTypeData: any;
  dynamicHtmlInputs: any;
  constructor(private readonly http: HttpClient) { }

  getBusinessProcessFormList() {
    return this.http.get(`${this.baseUrl}` + "/businessProcessForms/All");
  }



  getbusinessProcessValue(executionId: any, fromId: any) {
    return this.http.get(`${this.baseUrl}` + "/businessProcessfromvalue/" + executionId + "/" + fromId + "/byexecutionIdandfromId");
  }

  getBusinessProcessFormByFormId(formId: any) {
    return this.http.get(`${this.baseUrl}` + "/businessProcessForms/" + formId + "/byformId");
  }

  createBusinessProcessForm(data: any) {
    return this.http.post(`${this.baseUrl}` + "/businessProcessForms", data);
  }

  updateBusinessProcessForm(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessForms", data);
  }

  searchForms(data: any) {
    return this.http.post(`${this.baseUrl}` + "/businessProcessForms/searchForms", data);
  }

  deleteBusinessProcessForm(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data
    };
    return this.http.delete(`${this.baseUrl}` + "/businessProcessForms", httpOptions);
  }

  getFormFieldsList(formId: any) {
    return this.http.get(`${this.baseUrl}` + "/businessProcessFormFields/" + formId + "/byFormId");
  }

  searchFormFieldsByFieldLabel(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessFormFields/search", data);
  }

  getFormFieldByFieldId(fieldId: any) {
    return this.http.get(`${this.baseUrl}` + "/businessProcessFormFields/" + fieldId + "/byfieldId");
  }

  createBusinessProcessFormField(data: any) {
    return this.http.post(`${this.baseUrl}` + "/businessProcessFormFields", data);
  }

  updateBusinessProcessFormField(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessFormFields", data);
  }

  deleteBusinessProcessFormField(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data
    };
    return this.http.delete(`${this.baseUrl}` + "/businessProcessFormFields", httpOptions);
  }


  getFormFieldValidationById(formId: any, fieldId: any, validationId: any) {
    return this.http.get(`${this.baseUrl}` + "/formFieldValidations/" + formId + "/" + fieldId + "/" + validationId + "/byformIdAndfieldIdAndfieldValidationId");
  }

  createFormFieldValidation(data: any) {
    return this.http.post(`${this.baseUrl}` + "/formFieldValidations", data);
  }

  updateFormFieldValidation(data: any) {
    return this.http.put(`${this.baseUrl}` + "/formFieldValidations", data);
  }

  deleteFormFieldValidation(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data
    };
    return this.http.delete(`${this.baseUrl}` + "/formFieldValidations", httpOptions);
  }

  getValidationRules() {
    return this.http.get(`${this.baseUrl}` + "/formFieldValidations/getRules");
  }

  getRuleMsgAndLogic(data: any) {
    return this.http.put(`${this.baseUrl}` + "/formFieldValidations/validationRuleMsg", data);
  }

  getFormFieldRanges(formId: any, fieldId: any) {
    return this.http.get(`${this.baseUrl}` + "/formFieldRanges/" + formId + "/" + fieldId + "/byFormIdAndFieldId");
  }

  getFormFieldRangeById(formId: any, fieldId: any, rangeId: any) {
    return this.http.get(`${this.baseUrl}` + "/formFieldRanges/" + formId + "/" + fieldId + "/" + rangeId + "/byFormIdAndFieldIdAndRangeId");
  }

  createFormFieldRange(data: any) {
    return this.http.post(`${this.baseUrl}` + "/formFieldRanges", data);
  }

  updateFormFieldRange(data: any) {
    return this.http.put(`${this.baseUrl}` + "/formFieldRanges", data);
  }

  deleteFormFieldRange(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data
    };
    return this.http.delete(`${this.baseUrl}` + "/formFieldRanges", httpOptions);
  }



  getFormReferenceById(formId: any, referenceId: any) {
    return this.http.get(`${this.baseUrl}` + "/formReferences/" + formId + "/" + referenceId + "/byformIdAndreferenceId");
  }

  createFormReference(data: any) {
    return this.http.post(`${this.baseUrl}` + "/formReferences", data);
  }

  updateFormReference(data: any) {
    return this.http.put(`${this.baseUrl}` + "/formReferences", data);
  }

  deleteFormReference(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data
    };
    return this.http.delete(`${this.baseUrl}` + "/formReferences", httpOptions);
  }

  getExecutiveSetupsList() {
    return this.http.get(`${this.baseUrl}` + "/executionSetup/all");
  }

  getExecutiveSetupById(setupId: any) {
    return this.http.get(`${this.baseUrl}` + "/executionSetup/" + setupId + "/bySetupId");
  }

  getExecutiveSetupsListByStatus(status: any) {
    return this.http.get(`${this.baseUrl}` + "/executionSetup/" + status + "/byStatus");
  }

  getGroupsForExecution() {
    return this.http.get(`${this.baseUrl}` + "/executionSetup/groups");
  }

  createExecutiveSetup(data: any) {
    return this.http.post(`${this.baseUrl}` + "/executionSetup", data);
  }

  updateExecutiveSetup(data: any) {
    return this.http.put(`${this.baseUrl}` + "/executionSetup", data);
  }

  deleteExecutiveSetup(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data
    };
    return this.http.delete(`${this.baseUrl}` + "/executionSetup", httpOptions);
  }

  getExecutionFormSetupList(setupId: any) {
    return this.http.get(`${this.baseUrl}` + "/executionFormSetup/" + setupId + "/bySetUpId");
  }

  getExecutionFormSetupListByStage(setupId: any, stageId: any) {
    return this.http.get(`${this.baseUrl}` + "/executionFormSetup/" + setupId + "/" + stageId + "/byStage");
  }

  getExecutionFormSetupById(setupId: any, setupFormId: any) {
    return this.http.get(`${this.baseUrl}` + "/" + setupId + "/" + setupFormId + "/bySetupIdAndsetupFormId");
  }

  createExecutionFormSetup(data: any) {
    return this.http.post(`${this.baseUrl}` + "/executionFormSetup", data);
  }

  updateExecutionFormSetup(data: any) {
    return this.http.put(`${this.baseUrl}` + "/executionFormSetup", data);
  }

  deleteExecutionFormSetup(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data
    };
    return this.http.delete(`${this.baseUrl}` + "/executionFormSetup", httpOptions);
  }

  getExecutionUserSetupById(setupId: any, setupUserId: any) {
    return this.http.get(`${this.baseUrl}` + "/executionUserSetup/" + setupId + "/" + setupUserId + "/bySetupIdAndSetupUserId");
  }

  createExecutionUserSetup(data: any) {
    return this.http.post(`${this.baseUrl}` + "/executionUserSetup", data);
  }

  updateExecutionUserSetup(data: any) {
    return this.http.put(`${this.baseUrl}` + "/executionUserSetup", data);
  }

  getRecordNumber(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil", data);
  }

  updatefeildVslaue(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/save", data);
  }

  computeFeildValue(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/computefeild", data);
  }

  updatefeildVslaueOfFile(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/saveBlobFile", data);
  }

  recordData(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/getData", data);
  }

  getlistofFROM(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/getfromList", data);
  }

  getlistofeild(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/getfromfeildList", data);
  }
  addnewReord(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/addnewrecord", data);
  }

  recorddeleteData1(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/deleteRecord", data);

  }

  deleteExecutionUserSetup(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data
    };
    return this.http.delete(`${this.baseUrl}` + "/executionUserSetup", httpOptions);
  }

  getButtonLabelsForExecutionSetup(data: any) {
    return this.http.put(`${this.baseUrl}` + "/executionSetup/getButtonLabels", data);
  }

  performOperationsForExecutionSetup(data: any) {
    return this.http.put(`${this.baseUrl}` + "/executionSetup/performOperation", data);
  }

  getFormsList() {
    return this.http.get(`${this.baseUrl}` + "/forms/forReference/");
  }

  getExecutionByExecutionId(executionId: any) {
    return this.http.get(`${this.baseUrl}` + "/businessProcessExecutions/" + executionId + "/byExecutionId");
  }

  createExecution(data: any) {
    return this.http.post(`${this.baseUrl}` + "/businessProcessExecutions", data);
  }

  updateExecution(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessExecutions", data);
  }

  deleteExecution(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data
    };
    return this.http.delete(`${this.baseUrl}` + "/businessProcessExecutions", httpOptions);
  }


  getButtonListForExecutionLabels(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/bpexcutionlevellabel", data);
  }
  getButtonoperationForExecutionLabels(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/bpexcutionbuttonoperation", data);
  }

  getButtonoperationForExecutionrecordLabels(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/perfomrecodlevelbuttonoperation", data);
  }

  getButtonListForExecutionRecordLabels(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/bpexcutionrecordlevellabel", data);
  }

  switchWorkflowStage(data: any) {
    return this.http.put(`${this.baseUrl}` + "/businessProcessUtil/switchWorkflowstage", data);
  }
}
